import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup.FinancialDetailsSection', {
    financialDetailsHeader: 'Financial Details',
    currencyLabel: 'Default currency',
    bankAccountNumber: 'Bank account number',
    bankAccountNumberPlaceholder: 'Enter Bank account number',
    sortCodeLabel: 'Sort code',
    sortCodePlaceholder: 'Enter sort code',
    dropdownPlaceholder: 'Select option',
});
